import { createSlice } from "@reduxjs/toolkit";
import { Spotlight, Status } from "../../types/products-module-types";

type SpotlightState = {
  actualProductName: string;
  actualProductId: number | null;
  needRefreshSpotlight: boolean;
  lastSpotlight: Spotlight | null;
  spotlightHistory: Spotlight[];
  isLoadingDataSpotlight: boolean;
  spotlightStatuses: Status[];
  isSpotlightOn: boolean;
  isProductActive: boolean;
  isContentEditable: boolean;
};

const initialState: SpotlightState = {
  actualProductName: "",
  actualProductId: null,
  needRefreshSpotlight: false,
  lastSpotlight: null,
  spotlightHistory: [],
  isLoadingDataSpotlight: true,
  spotlightStatuses: [],
  isSpotlightOn: true,
  isProductActive: true,
  isContentEditable: true,
};

export const spotlightSlice = createSlice({
  name: "spotlight",
  initialState,
  reducers: {
    loadSpotlightStatuses: (state, action) => {
      state.spotlightStatuses = action.payload.spotlightStatuses;
    },
    loadSpotlightData: (state, action) => {
      state.actualProductId = action.payload.productId;
      state.lastSpotlight = action.payload.lastSpotlightInfo.lastSpotlight;
      state.actualProductName = action.payload.lastSpotlightInfo.productName;
      state.isSpotlightOn = action.payload.lastSpotlightInfo.isSpotlightOn;
      state.isProductActive = action.payload.lastSpotlightInfo.isProductActive;
      state.isContentEditable = action.payload.lastSpotlightInfo.isContentEditable;
      state.spotlightHistory = action.payload.spotlightHistory;
      state.isLoadingDataSpotlight = false;
      state.needRefreshSpotlight = false;
    },
    // loadLastSpotlightData: (state, action) => {
    //   state.isLoadingData = true;
    //   state.lastSpotlight = action.payload.lastSpotlight;
    //   state.spotlightHistory = action.payload.spotlightHistory;
    //   state.isLoadingData = false;
    // },
    setIsLoadingDataSpotlight: (state, action) => {
      state.isLoadingDataSpotlight = action.payload;
    },
    setIsSpotlightOn: (state, action) => {
      state.isSpotlightOn = action.payload;
    },
    setNeedRefreshSpotlight: (state, action) => {
      state.needRefreshSpotlight = action.payload;
    },
    clear: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const {
  loadSpotlightStatuses,
  loadSpotlightData,
  // loadLastSpotlightData,
  setIsLoadingDataSpotlight,
  setIsSpotlightOn,
  setNeedRefreshSpotlight,
  clear,
} = spotlightSlice.actions;

export const IsLoadingDataSpotlight = (state: any) => {
  return state.spotlight.isLoadingDataSpotlight;
};

export const IsSpotlightOn = (state: any) => {
  return state.spotlight.isSpotlightOn;
};

export const IsProductActive = (state: any) => {
  return state.spotlight.isProductActive;
};

export const IsContentEditable = (state: any) => {
  return state.spotlight.isContentEditable;
};

export const GetActualProductName = (state: any) => {
  return state.spotlight.actualProductName;
};

export const SelectActualProductId = (state: any) => {
  return state.spotlight.actualProductId;
};

export const LastSpotlight = (state: any) => {
  return state.spotlight.lastSpotlight;
};

export const SpotlightHistory = (state: any) => {
  return state.spotlight.spotlightHistory;
};

export const SpotlightStatuses = (state: any) => {
  return state.spotlight.spotlightStatuses;
};

export const SelectNeedRefreshSpotlight = (state: any) => {
  return state.spotlight.needRefreshSpotlight;
};

export default spotlightSlice.reducer;
